import { NotificationPosition } from 'core/enums';
import { Logo, Notification } from 'coreOld/components';
import { Icon, WrapperBlock } from 'coreOld/elements';

import { CloseButton, SubtitleModal, TitleModal, WrapTop, logoStyle } from './modalHeaderStyle';

interface IProps {
  title: string;
  subtitle?: string | JSX.Element;
  logoPath?: string;
  closeModal: (reset) => void;
  hasContent?: boolean;
  flex?: number;
  height?: number;
}

const ModalHeader = ({ title, subtitle, logoPath, closeModal, hasContent }: IProps) => {
  return (
    <WrapperBlock noContent={!hasContent}>
      <WrapTop>
        <Logo path={logoPath} style={logoStyle} />
        <CloseButton type="button" onClick={closeModal}>
          <Icon name={Icon.CLOSE} />
        </CloseButton>
      </WrapTop>

      <TitleModal>{title}</TitleModal>

      <SubtitleModal>{subtitle}</SubtitleModal>

      <Notification position={NotificationPosition.MODAL} />
    </WrapperBlock>
  );
};

export default ModalHeader;
